import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { Flex, Box } from 'reflexbox';

import { Button } from '../../../../components/Marketing/Button';
import image2 from './images/image2.png';
import { MARKETING_PAGE_BREAKPOINT_DESKTOP } from '../../../../components/Style/breakpoints';

const Container = styled(Flex)`
  flex-direction: column-reverse;
  margin-top: 40px;
  margin-bottom: 40px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    flex-direction: initial;
  }
`;

const SubContainer = styled(Flex)`
  flex-direction: column;
  padding: 15px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    // padding-left: 30px;
    width: 50%;
  }
`;

const Title = styled(Box)`
  font-weight: 900;
  font-size: 14px;
  line-height: 130%;
  color: #b0b6c2;
  padding-bottom: 12px;
`;

const ImageHolder = styled(Flex)`
  flex-direction: column;
  padding-left: 0px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    padding: 15px;
    width: 50%;
  }
  img {
    width: 100%;
    height: auto;
  }
`;

const ContainerInner = styled.div`
  max-width: 960px;
  width: 100%;
  flex-direction: row;
  display: flex;
  // padding: 2px;
  margin-bottom: 40px;
  @media only screen and (min-width: 960px) {
    padding: 12px;
    > div {
      width: 50%;
    }
    > img {
      width: 50%;
    }
    margin-bottom: 0px;
  }
  img {
    display: none;
    @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
      display: block;
    }
  }
`;

const Heading = styled.div`
  font-size: 26px;
  font-weight: 900;
  line-height: 120%;
  letter-spacing: -0.01em;
  color: #041416;
  padding-bottom: 24px;

  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    font-size: 36px;
  }
`;

const SubHeading = styled(Box)`
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #7c8788;
  padding-bottom: 24px;
`;

const ButtonContainer = styled(Flex)`
  justify-content: center;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: start;
  }
`;
export const TheDifference = (): ReactElement => {
  return (
    <Container>
      <ContainerInner>
        <ImageHolder>
          <img alt="" src={image2} />
        </ImageHolder>
        <SubContainer>
          <Title>THE DIFFERENCE</Title>
          <Heading>How we’re raising the standard of education</Heading>
          <SubHeading>
            Our approach considers the latest learning sciences research,
            advances in technology and a deep understanding of the local
            regulatory environment to deliver superior outcomes for learners.
          </SubHeading>
          <ButtonContainer>
            <Button
              variant="primary"
              action={{
                kind: 'external_link',
                value:
                  'https://solutions.openlearning.com/learning-philosophy/',
                target: '_blank',
              }}
            >
              Learn about our philosophy
            </Button>
          </ButtonContainer>
        </SubContainer>
      </ContainerInner>
    </Container>
  );
};
